module.exports = __webpack_public_path__ + "static/portalsaboresLogo-5739e577cbacf74b5e528cb1ba2643d5.svg";